<!-- Container-fluid starts-->
<div class="container-fluid">
  <div class="row">
    <div class="col-sm-12">
      <div class="card">
        <div class="card-header">
          <h5>Gestionare roluri</h5>
        </div>
        <!--<div class="col-xl-3 col-sm-3 mb-0">
          <label>Companie</label>
          <select class="form-control digits" (change)="onCompanySelect($event)">
            <option *ngFor="let company of companies" [value]="company.cui">
              {{company.name}}
            </option>
          </select>
        </div>-->
        <div class="row pl-3 mt-1">
          <div class="col-xl-3 col-sm-3">
            <label>CUI</label>
            <input class="form-control" type="text" [ngModel]="companyCode" disabled />
          </div>
          <div class="col-xl-3 col-sm-3">
            <label>Denumire PJ</label>
            <input class="form-control" type="text" [ngModel]="companyName" disabled />
          </div>
        </div>
        <div class="card-body">
          <div class="btn-popup pull-left">
            <button class="btn btn-primary"
                    (click)="addLegalRepresentative()"
                    [disabled]="isAddingLegalRepresentative">
              Adauga invitatie cont
            </button>
          </div>
          <div id="batchDelete" class="category-table custom-datatable">
            <div class="table-responsive">
              <ng2-smart-table [settings]="settings"
                               [source]="legalRepresentatives">

              </ng2-smart-table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- Container-fluid Ends-->
